import { z } from "zod";

export const Step5Schema = z.object({
  contactFullName: z.string().min(1, "onboarding.validation.fullNameRequired"),
  acceptContractEmail: z.boolean().refine((val) => val === true, {
    message: "onboarding.validation.acceptContractEmailRequired",
  }),
  acceptTerms: z.boolean().refine((val) => val === true, {
    message: "onboarding.validation.acceptTermsRequired",
  }),
  acceptPrivacyNotice: z.boolean().refine((val) => val === true, {
    message: "onboarding.validation.acceptPrivacyNoticeRequired",
  }),
});

export type Step5Input = z.infer<typeof Step5Schema>;
